import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";

const TagCategoriesApiService = async (): Promise<string[]> => {
  const { data } = await axios.get("/employertag/category-names/");
  return data;
};

const useTagCategoriesApiService = (): UseQueryResult<string[], AxiosError> =>
  useQuery<string[], AxiosError>(
    ["TagCategoriesApiService"],
    TagCategoriesApiService
  );

export default useTagCategoriesApiService;
